// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3toou","footer":"Form_footer__bOmS9"};